export default "__VITE_ASSET__BUWN5KOq__"